const settingInitData = {
  paymentType: {},
  options: [],
  channel: [],
  tags: []
};

export default settingInitData;
